"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _inline_svg = require("./inline_svg.utils");
var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));
const SportsCricket = props => {
  const {
    fontsize,
    themeColor,
    ...rest
  } = props;
  const theme = _react.default.useContext(_styledComponents.ThemeContext);
  const {
    sizeStyles,
    colorStyles
  } = (0, _inline_svg.parseStyles)({
    fontsize,
    themeColor
  }, theme);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, sizeStyles, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    // eslint-disable-next-line max-len
    d: "M5.9949 16.9209L1.22449 21.2069C0.719388 21.6773 1.22449 21.9909 1.22449 21.9909L2.12245 22.9317C2.51531 23.1931 3.18878 22.6181 3.18878 22.6181L7.67857 18.8026C8.68878 18.0708 9.25 18.489 9.25 18.489L6.10714 15.6665C6.27551 16.0324 5.9949 16.9209 5.9949 16.9209Z",
    fill: "#75767A"
  }, colorStyles)), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    // eslint-disable-next-line max-len
    d: "M19.3767 1.0585C18.5115 0.787392 17.7544 1.54651 17.7544 1.54651L6.66824 12.5537C6.28969 12.9333 6.66824 13.4755 6.66824 13.4755L10.616 17.3795C10.8864 17.6506 11.5894 17.3795 11.5894 17.3795L22.4592 6.53499C23 6.15543 23 5.28787 23 5.28787C23 2.79363 19.3767 1.0585 19.3767 1.0585Z",
    fill: "#75767A"
  }, colorStyles)), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    // eslint-disable-next-line max-len
    d: "M8.90259 4.65976C9.13398 4.25947 9.24967 3.85919 9.24967 3.40172C9.24967 2.08649 8.15058 1 6.82009 1C6.41516 1 6.01023 1.11437 5.6053 1.28592C5.31606 4.48821 7.91919 4.71694 8.90259 4.65976Z",
    fill: "#75767A"
  }, colorStyles)), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    // eslint-disable-next-line max-len
    d: "M6.89888 5.58317C7.43028 5.58317 7.96168 5.38226 8.33366 5.08089C5.25153 4.67906 5.25153 2.66993 5.41095 1.9165C4.93269 2.31833 4.66699 2.87084 4.66699 3.47358C4.66699 4.62883 5.67665 5.58317 6.89888 5.58317Z",
    fill: "#75767A"
  }, colorStyles)));
};
SportsCricket.propTypes = _inline_svg2.default.propTypes;
SportsCricket.defaultProps = _inline_svg2.default.defaultProps;
var _default = exports.default = SportsCricket;